<template>
  <section class="old-examination">
    <div class="osk-wrapper">
      <div class="old-examination__image-block">
        <img
          class="old-examination__image"
          src="//static.oskelly.ru/images/icons/guarantees_img.png"
          :alt="$t('components.home.old.examination.startSale')"
        >
      </div>

      <div class="old-examination__content">
        <h2 class="section-title old-examination__title">
          {{ $t('components.home.old.examination.title') }}
        </h2>

        <p class="old-examination__text">
          {{ $t('components.home.old.examination.text1') }}
        </p>

        <p class="old-examination__text">
          {{ $t('components.home.old.examination.text2') }}
        </p>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.old-examination {
  padding: 51px 0 23px;

  @media screen and (min-width: 1024px) {
    padding: 118px 0 100px;
  }

  .osk-wrapper {
    display: flex;
    flex-direction: column;

    @media screen and (min-width: 1024px) {
      align-items: center;
      justify-content: space-between;
      flex-direction: row;
      padding: 42px 66px 34px;
      max-width: 1114px;
    }
  }

  &__title {
    font-size: 20px;
    margin-bottom: 12px;
    line-height: 26px;

    @media screen and (min-width: 1024px) {
      margin-bottom: 14px;
      font-size: 34px;
      line-height: 37px;
      color: #202020;
      letter-spacing: 1.5px;
    }
  }

  &__content {
    margin-top: 50px;

    @media screen and (min-width: 1024px) {
      width: calc(100% - 350px);
      padding-left: 98px;
      margin-top: 0;
    }
  }

  &__text {
    font-size: 12px;
    line-height: 17px;

    &:not(:last-child) {
      margin-bottom: 20px;
    }

    @media screen and (min-width: 1024px) {
      font-size: 16px;
      line-height: 24px;
    }
  }

  &__image-block {
    width: 167px;
    margin: 0 auto;

    @media screen and (min-width: 1024px) {
      width: 320px;
      margin: 0;
    }
  }

  &__image {
    width: 100%;
  }
}
</style>
